import { useContext } from "react";
import DataConfigContext from "./DataConfigContext";
export default function useDataConfig() {
    return useContext(DataConfigContext);
}

//# sourceMappingURL=useDataConfig.js.map